import React from 'react'
import FundRow from './FundRow'
import { Button } from 'antd';

class FundsTable extends React.Component {
    render() {
        let onTableUpdate = this.props.onTableUpdate;
        let rowDel = this.props.onRowDel;
        var Funds = this.props.funds.map(function (fund) {
            if (fund.deleted) {
                return null;
            }
            return (<FundRow key={fund.fundId}
                onTableUpdate= {onTableUpdate}
                onDelEvent={rowDel}
                fund={fund} 
                />)
        });
        
        return (
          <div className="content">
            <h2>{this.props.title}</h2>
            <div className="ant-table-wrapper">
            <div className="ant-table-content">
                <table className="">
                    <thead className="ant-table-thead">
                        <tr>
                            <th>Description</th>
                            <th>Sort Order</th>
                            <th>Default</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody className="ant-table-tbody">
                        {Funds}
                    </tbody>
                </table>
                <Button type="primary" icon="plus" onClick={this.props.onRowAdd}>Add</Button>&nbsp;
                <Button htmlType="submit" type="primary" onClick={this.props.onSave} icon="save">Save</Button>
            </div></div></div>
        );

    }
}



export default FundsTable